import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RoomIcon from '@mui/icons-material/Room';

const labRequests = [
  { id: 1, name: 'Chest X-Ray scan', location: 'Lifeline Medical Diagnostic Centre, Ilupeju' },
  { id: 2, name: 'MRI scan', location: 'Lifeline Medical Diagnostic Centre, Ilupeju' },
  { id: 3, name: 'Bloodwork', location: 'In-house' },
];

const LabWorkRequest = () => {
  return (
    <Box sx={{ p: 2, backgroundColor: '#eaffe0', minHeight: '100vh' }}>
      <Grid container alignItems="center" spacing={1}>
        <Grid item>
          <ArrowBackIcon sx={{ fontSize: 28 }} />
        </Grid>
        <Grid item>
          <Typography variant="h6" fontWeight="bold" color="green">
            Lab Work Request
          </Typography>
        </Grid>
      </Grid>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: '#aaff80' }}>
            <TableRow>
              <TableCell><strong>S/n</strong></TableCell>
              <TableCell><strong>Lab Request</strong></TableCell>
              <TableCell><strong>Test Location</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {labRequests.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.id}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>{item.location}</Grid>
                    <Grid item>
                      <RoomIcon fontSize="small" color="success" />
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 3, ml: 1 }}>
        <Typography><strong>Lab Work Cost:</strong> N15,250.00</Typography>
        <Typography><strong>HMO Cover:</strong> N15,250.00</Typography>
        <Typography><strong>Your Contribution:</strong> N0.00</Typography>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Paper sx={{ border: '2px solid #2196f3' }}>
          <Box sx={{ backgroundColor: '#aaff80', p: 1 }}>
            <Typography fontWeight="bold">Additional Note</Typography>
          </Box>
          <Box sx={{ p: 2 }}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              placeholder="Enter additional notes here"
            />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default LabWorkRequest;
